import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';

interface GetAreasOfWorkOptions {
  lang?: string;
  showEmptyCategories?: boolean;
  isLocalizedAreasOfWorkByClientProblem?: boolean;
}

export const getAreasOfWorkByClientProblem = async ({
  lang = 'uk',
  showEmptyCategories,
  isLocalizedAreasOfWorkByClientProblem,
}: GetAreasOfWorkOptions = {}) => {
  const url = new URL(`${environment.WORK_TAXONOMY_APP_URL}/areas-of-work/by-problem/${lang}`);

  if (showEmptyCategories !== undefined) {
    url.searchParams.set('showEmptyCategories', String(showEmptyCategories));
  }

  url.searchParams.set('isLocalizedAreasOfWorkByClientProblem', String(isLocalizedAreasOfWorkByClientProblem));

  const { data: worksData } = await HttpHandler({
    method: 'GET',
    url: url.toString(),
  });

  return worksData?.data;
};

export const getLocalizedAreasOfWorkByClientProblemNames = async (lang: string, ids: Array<string>) => {
  const queryParam = ids.map(encodeURIComponent).join(',');

  const { data: worksData } = await HttpHandler({
    method: 'GET',
    url: `${environment.WORK_TAXONOMY_APP_URL}/areas-of-work/by-problem/localized-names/${lang || 'uk'}?ids=${queryParam}`,
  });

  return worksData?.data;
};
